import{McListItem as t}from"@maersk-global/mds-components-core-list-item";var e=class extends t{};customElements.get("mc-option")||customElements.define("mc-option",e);export{e as McOption};
